export enum StateActionsTypes {
  "LIST_STATE" = "LIST_STATE"
}

export enum StateMutationsTypes {
  "SET_STATE" = "SET_STATE"
}

export enum StateGettersTypes {
  "STATE_BY_ID" = "STATE_BY_ID",
  "STATE_ALL_ID" = "STATE_ALL_ID"
}
